import type { FC, HTMLAttributes } from 'react';
import type { LinkProps } from 'react-router';
import { Link } from 'react-router';
import type { ButtonProps } from 'src/components/buttons-and-actions/button';
import { Button } from 'src/components/buttons-and-actions/button';
import { Card } from 'src/components/data-display/card';
import { EmptyValue } from 'src/components/data-display/empty-value';
import type { StrictOmit } from 'src/utils/utility-types';

type WithButton = {
  label: string;
  button: StrictOmit<ButtonProps, 'onClick'> & {
    onClick: () => void;
  };
  link?: undefined;
};

type WithLink = {
  label: string;
  button?: undefined;
  link: LinkProps;
};

type Regular = {
  label: string;
  button?: undefined;
  link?: undefined;
};

export type EmptyCardProps = (WithButton | WithLink | Regular) &
  HTMLAttributes<HTMLDivElement>;

/**
 * @deprecated Use [EmptyDataset](https://storybook.service.prisma-capacity.cloud/master/?path=/docs/components-data-display-empty-dataset--docs) component instead.
 */
export const EmptyCard: FC<EmptyCardProps> = ({
  label,
  button,
  link,
  ...rest
}) => {
  return (
    <Card data-testid="empty-card" {...rest}>
      <div
        className={`
          grid grid-flow-row place-items-center justify-center gap-md
          lg:grid-flow-col lg:[justify-items:legacy] lg:text-start
          legacy:gap-[1rem]
        `}
      >
        <EmptyValue label={label} />

        {button && (
          <Button
            data-testid="empty-action-button"
            mode="secondary"
            size="small"
            {...button}
          >
            Reset Filters
          </Button>
        )}

        {link && <Link data-testid="empty-action-link" {...link} />}
      </div>
    </Card>
  );
};
